import { catMenuConst } from '../constants/actionConstants'
import produce from 'immer';
const initState = {
  menusList: { obj: [] },
  menusListByRole: { obj: [] },
  menuChilds: { obj: [] },
  menuPublicList: { obj: [] },
  pending: false,
  error: false
};

export default (state = initState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case catMenuConst.GET_MENU_LIST:
        draft.pending = true;
        break;
      case catMenuConst.GET_MENU_LIST_SUCCESS:
        draft.pending = false;
        draft.menusList = action.payload;
        break;

      case catMenuConst.GET_MENU_LIST_BY_ROLE:
        draft.pending = true;
        break;
      case catMenuConst.GET_MENU_LIST_BY_ROLE_SUCCESS:
        draft.pending = false;
        draft.menusListByRole = action.payload;
        break;

      case catMenuConst.GET_MENU_CHILDS:
        draft.pending = true;
        break;
      case catMenuConst.GET_MENU_CHILDS_SUCCESS:
        draft.pending = false;
        draft.menusListByRole = action.payload;
        break;

      case catMenuConst.GET_MENU_TREE_PUBLIC:
        draft.pending = true;
        break;
      case catMenuConst.GET_MENU_TREE_PUBLIC_SUCCESS:
        draft.pending = false;
        draft.menuPublicList = action.payload;
        break;
      case catMenuConst.MENU_RESET_STATE:
        return initState
      default:
        return state
    }
  })
